import { forwardRef } from 'react';

import { WithStyles, createStyles, withStyles } from '@material-ui/core';

import classNames from 'classnames';

import { Flex, FlexProps } from '@backstage/ui';

const styles = createStyles({
  root: {
    display: 'inline-flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
  },
});

export interface ExpressionRootProps
  extends FlexProps,
    WithStyles<typeof styles> {}

const ExpressionRoot = forwardRef<HTMLDivElement, ExpressionRootProps>(
  (props, ref) => {
    const { classes, className, ...rest } = props;
    return (
      <Flex
        ref={ref}
        direction="row"
        className={classNames(className, classes.root)}
        gap="1"
        {...rest}
      />
    );
  },
);

ExpressionRoot.displayName = 'Expression.Root';

export default withStyles(styles)(ExpressionRoot);
